import React, { FC, useEffect, useState, useRef } from 'react';
import { RootState, useDispatch, useSelector } from 'src/store';
import { pagesReset } from 'src/store/modules/pages';
import CloseIcon from '@material-ui/icons/Close';
import { editTextReset } from 'src/store/modules/editText';
import { buttonsReset } from 'src/store/modules/buttons';
import { imageReset } from 'src/store/modules/imageUpload';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';
import setInitValue from 'src/utils/setInitValue';
import { editUserCompany } from 'src/store/modules/client';
import { customlogReset } from 'src/store/modules/customlog';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';
import ReplayIcon from '@material-ui/icons/Replay';
import { changeEnter } from 'src/utils/changeEnter';
import { initTrackingValues } from '../TemplateTracking/BasicScratchModalTracking';

const CONFIG = {
  threshold: 0.3,
  lineWidth: 40,
  maxSize: 480,
  imagePath:
    'data:image/png;base64,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'
};

const initValue = {
  currentIndex: 0,
  bg: 'color',
  bgOpacity: { bgDimmed: 70 },
  bgImage: {
    image: 'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp'
  },
  bgColor: { background: '#F5F5DC' },
  radius: { background: 14, image: 4, button: 4 },
  deeplink: {
    background: 'https://www.inappmessage.com/'
  },

  text: {
    title: 'Scratch & Win!',
    sub_title: 'Complete 5 episodes today and get 10 Coins instantly!'
  },
  fontSize: { title: 1.25, sub_title: 0.8125 },
  fontWeight: { title: 700, sub_title: 400 },
  color: { title: '#000000', sub_title: '#000000' },
  fontFamily: { title: 'Inter', sub_title: 'Inter' },
  textAlign: { title: 'center', sub_title: 'center' },

  btnText: {
    button: 'Get Reward',
    bottom_left_button: "Don't show again",
    bottom_right_button: 'Close'
  },
  btnFontSize: {
    button: 0.9375,
    bottom_left_button: 0.875,
    bottom_right_button: 0.875
  },
  btnFontWeight: {
    button: 700,
    bottom_left_button: 400,
    bottom_right_button: 400
  },
  btnColor: {
    button: '#ffffff',
    bottom_left_button: '#ffffff',
    bottom_right_button: '#ffffff'
  },
  btnBgColorR: { button: 0, bottom_left_button: 0, bottom_right_button: 0 },
  btnBgColorG: {
    button: 170,
    bottom_left_button: 0,
    bottom_right_button: 0
  },
  btnBgColorB: {
    button: 255,
    bottom_left_button: 0,
    bottom_right_button: 0
  },
  btnBgColorA: {
    button: 1,
    bottom_left_button: 0,
    bottom_right_button: 0
  },
  btnFontFamily: {
    button: 'Inter',
    bottom_left_button: 'Inter',
    bottom_right_button: 'Inter'
  },
  btnAgain: {
    type: '',
    bottom_left_button: 'opt-in'
  },
  button1: {
    button: [],
    bottom_left_button: [],
    bottom_right_button: []
  },
  button2: {
    button: [],
    bottom_left_button: [],
    bottom_right_button: []
  }
};

const BasicScratchModal: FC<any> = () => {
  const dispatch = useDispatch();
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const scratchState = useRef({
    isDrawing: false,
    isRevealed: false,
    lastX: 0,
    lastY: 0
  });

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {}
    }
    getUserId();
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    const container = containerRef.current;
    if (!canvas || !container) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const initializeCanvas = () => {
      const canvas = canvasRef.current;
      const container = containerRef.current;
      const ctx = canvas?.getContext('2d');
      if (!canvas || !container || !ctx) return;

      const size = container.clientWidth;
      canvas.width = size;
      canvas.height = size;
      canvas.style.width = '100%';
      canvas.style.height = '100%';

      // 캔버스 초기화 후 스크래치 이미지 다시 그리기
      const scratchImage = new Image();
      scratchImage.src = CONFIG.imagePath;
      scratchImage.onload = () => {
        ctx.drawImage(
          scratchImage,
          -5,
          0,
          canvas.width + 10,
          canvas.height + 10
        );
      };

      // 이전 스크래치 상태 유지
      if (scratchState.current.isRevealed) {
        canvas.classList.add('revealed');
        const button = document.querySelector('.btn_wrapper button');
        if (button instanceof HTMLButtonElement) {
          button.style.opacity = '1';
          button.disabled = false;
        }
      }
    };

    const setupContext = () => {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = CONFIG.lineWidth;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
    };

    const checkProgress = () => {
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixels = imageData.data;
      const scratchedPixels = pixels.filter(
        (_, i) => i % 4 === 3 && pixels[i] === 0
      ).length;
      const progress = scratchedPixels / (canvas.width * canvas.height);

      if (progress > CONFIG.threshold && !scratchState.current.isRevealed) {
        scratchState.current.isRevealed = true;
        canvas.classList.add('revealed');
        const button = document.querySelector('.btn_wrapper button');
        if (button instanceof HTMLButtonElement) {
          button.style.opacity = '1';
          button.disabled = false;
        }
      }
    };

    const handleStart = (e: MouseEvent | TouchEvent) => {
      scratchState.current.isDrawing = true;
      const pos = getPosition(e);
      scratchState.current.lastX = pos.x;
      scratchState.current.lastY = pos.y;
    };

    const handleMove = (e: MouseEvent | TouchEvent) => {
      if (!scratchState.current.isDrawing || scratchState.current.isRevealed)
        return;
      e.preventDefault();

      const pos = getPosition(e);
      setupContext();
      drawScratchLine(
        ctx,
        { x: scratchState.current.lastX, y: scratchState.current.lastY },
        { x: pos.x, y: pos.y }
      );

      scratchState.current.lastX = pos.x;
      scratchState.current.lastY = pos.y;

      // checkProgress();
    };

    const handleEnd = () => {
      if (scratchState.current.isDrawing) {
        checkProgress(); // 손을 뗄 때 진행률 체크
      }
      scratchState.current.isDrawing = false;
    };

    const getPosition = (e: MouseEvent | TouchEvent) => {
      const rect = canvas.getBoundingClientRect();
      const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      const clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      return {
        x: clientX - rect.left,
        y: clientY - rect.top
      };
    };

    const drawScratchLine = (
      ctx: CanvasRenderingContext2D,
      from: { x: number; y: number },
      to: { x: number; y: number }
    ) => {
      const midPoint = {
        x: (from.x + to.x) / 2,
        y: (from.y + to.y) / 2
      };

      ctx.beginPath();
      ctx.moveTo(from.x, from.y);
      ctx.quadraticCurveTo(from.x, from.y, midPoint.x, midPoint.y);
      ctx.lineTo(to.x, to.y);
      ctx.stroke();
    };

    initializeCanvas();

    const scratchImage = new Image();
    scratchImage.src = CONFIG.imagePath;
    scratchImage.onload = () => {
      ctx.drawImage(scratchImage, -5, 0, canvas.width + 10, canvas.height + 10);
    };

    canvas.addEventListener('mousedown', handleStart);
    canvas.addEventListener('mousemove', handleMove);
    canvas.addEventListener('mouseup', handleEnd);
    canvas.addEventListener('touchstart', handleStart);
    canvas.addEventListener('touchmove', handleMove);
    canvas.addEventListener('touchend', handleEnd);

    window.addEventListener('resize', initializeCanvas);

    return () => {
      canvas.removeEventListener('mousedown', handleStart);
      canvas.removeEventListener('mousemove', handleMove);
      canvas.removeEventListener('mouseup', handleEnd);
      canvas.removeEventListener('touchstart', handleStart);
      canvas.removeEventListener('touchmove', handleMove);
      canvas.removeEventListener('touchend', handleEnd);
      window.removeEventListener('resize', initializeCanvas);
    };
  }, []);

  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  const resetScratch = () => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext('2d');
    if (!canvas || !ctx) return;

    // 스크래치 상태 초기화
    scratchState.current = {
      isDrawing: false,
      isRevealed: false,
      lastX: 0,
      lastY: 0
    };

    // 캔버스 초기화
    canvas.classList.remove('revealed');

    // 캔버스 컨텍스트 완전 초기화
    ctx.globalCompositeOperation = 'source-over';
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.globalCompositeOperation = 'destination-out';

    // 버튼 비활성화
    const button = document.querySelector('.btn_wrapper button');
    if (button instanceof HTMLButtonElement) {
      button.style.opacity = '0.5';
      button.disabled = true;
    }

    // 스크래치 이미지 다시 그리기
    const scratchImage = new Image();
    scratchImage.src = CONFIG.imagePath;
    scratchImage.onload = () => {
      ctx.globalCompositeOperation = 'source-over';
      ctx.drawImage(scratchImage, -5, 0, canvas.width + 10, canvas.height + 10);
      ctx.globalCompositeOperation = 'destination-out';
    };
  };
  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const buttonURL = getFontURL(btnFontFamily?.button);
  const bottomLeftButtonURL = getFontURL(btnFontFamily?.bottom_left_button);
  const bottomRightButtonURL = getFontURL(btnFontFamily?.bottom_right_button);

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initValue, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(customlogReset());
      dispatch(trackingReset());
    };
  }, []);

  const style = `
  @font-face {
    font-family: 'title';
    src: url(${titleFontURL});
  }
  @font-face {
    font-family: 'sub_title';
    src: url(${subTitleFontURL});
  }
  @font-face {
    font-family: 'button';
    src: url(${buttonURL});
  }
  @font-face {
    font-family: 'bottom_left_button';
    src: url(${bottomLeftButtonURL});
  }
  @font-face {
    font-family: 'bottom_right_button';
    src: url(${bottomRightButtonURL});
  }
    
    .root_view {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      position: relative;
      background: none;
    }

    .background {      
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, ${displayValue});
    }    
    .center {
      width: 310px;
      position: absolute;
      overflow: hidden;
      top: 50%;
      transform: translate(0%, -50%);
      display: flex;
      flex-direction: column;
    }

    .modal_wrapper {        
      display: flex;
      flex-direction: column;
      padding: 8px 8px 0px 8px;
      border-radius: ${radius?.background}px;

      background: ${bgColor?.background};

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
   
    .contents_wrapper {
      width: 100%;
    }

    .contents_box {
      width: 100%;
      height: 100%;
      margin-top: 20px;
    }

    .contents_box .title {
      width: 100%;      
      display: flex;
      align-items: center;
      margin-bottom: 7px;
    }
    
    .title .title_inner {
      width: 100%;
      text-align: ${textAlign?.title};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.4;
      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily.title
          : 'title'
      };
    }

    .contents_box .sub_title {
      width: 100%;
      height: 100%
      display: flex;
      align-items: center;
    }

    .contents_box .sub_title_inner {
      width: 100%;  
      text-align: ${textAlign?.sub_title};
      text-overflow: ellipsis;
      overflow: hidden;
      line-height: 1.54;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      
      color: ${color?.sub_title};
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily.sub_title
          : 'sub_title'
      };
    }

    .btn_wrapper {
      width: 100%;
      margin: 16px 0px 20px 0px;
    }
    .btn_wrapper button {
      width: 100%;
      height: 48px;
      outline: 0;
      border: 0;
      padding: 0 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      color: ${btnColor?.button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily.button
          : 'button'
      };
      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
    }

    .bottom_wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 11px
    }
    
    .bottom_wrapper .style01 {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 8px;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.bottom_left_button};      
      font-weight: ${btnFontWeight?.bottom_left_button};
      font-size: ${btnFontSize?.bottom_left_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.bottom_left_button
        )
          ? btnFontFamily.bottom_left_button
          : 'bottom_left_button'
      };
    }
    .bottom_wrapper .style02 {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: right;
      color: ${btnColor?.bottom_right_button};      
      font-weight: ${btnFontWeight?.bottom_right_button};
      font-size: ${btnFontSize?.bottom_right_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.bottom_right_button
        )
          ? btnFontFamily.bottom_right_button
          : 'bottom_right_button'
      };
    }
      /* scratch css */

		.scratch-container {
			position: relative;
		}

		#scratchCard {
			border-radius: ${radius?.image}px;
			position: absolute;
			top: 0;
			left: 0;
      background: none;
			opacity: 1;
			transition: opacity 0.8s ease-out;
		}

		#scratchCard.revealed {
			opacity: 0;
		}

		#resultContainer {
			border-radius: ${radius?.image}px;
			width: 100%;
			height: 100%;

			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 24px;
			font-weight: bold;
			color: #000000;
			background-color: ${bgColor?.background};
		}
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view">
        <div className="background" />
        <div
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            display: 'flex',
            alignItems: 'center',
            padding: '8px',
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            cursor: 'pointer',
            zIndex: 10
          }}
          onClick={resetScratch}
        >
          <ReplayIcon
            style={{
              fontSize: '24px',
              color: '#ffffff'
            }}
          />
        </div>
        <div className="center">
          <div className="modal_wrapper">
            <div style={{ width: '100%', height: '100%' }}>
              <div ref={containerRef} className="scratch-container">
                <div id="resultContainer">
                  <img
                    style={{
                      width: '295px',
                      height: '295px',
                      borderRadius: `${radius?.image}px`,
                      objectFit: 'cover'
                    }}
                    src={bgImage?.image}
                    alt="result"
                  />
                </div>
                <canvas ref={canvasRef} id="scratchCard" width="0" height="0" />
              </div>
            </div>
            <div className="contents_wrapper">
              <div className="contents_box">
                <div className="title">
                  <div className="title_inner">{changeEnter(text?.title)}</div>
                </div>
                <div className="sub_title">
                  <div className="sub_title_inner">
                    {changeEnter(text?.sub_title)}
                  </div>
                </div>
              </div>
              <div className="btn_wrapper">
                <button style={{ opacity: '0.5' }} disabled>
                  {btnText?.button}
                </button>
              </div>
            </div>
          </div>
          <div className="bottom_wrapper">
            <span className="style01">{btnText?.bottom_left_button}</span>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className="style02">{btnText?.bottom_right_button}</span>
              <CloseIcon
                style={{
                  fontSize: `${btnFontSize?.bottom_right_button + 0.25}rem`,
                  color: `${btnColor?.bottom_right_button}`
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicScratchModal;
